var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"id":_vm.id,"hide-footer":"","hide-header":"","size":"sm"}},[_c('p',{staticClass:"text-center"},[_vm._v(" "+_vm._s(_vm.confirm_text)+" ")]),_c('btn-loader',{attrs:{"variant":_vm.variant,"text":_vm.btn_text,"loader":_vm.loading},on:{"clicked":_vm.confirm}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }